class YouAreIn extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.checkFirstTimeAccess()
  }

  getCookie(name) {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) == ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }

  setCookie(name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    const expires = 'expires=' + date.toUTCString()

    // For Pantheon wp- cookies, use simplified settings
    // Pantheon handles domain/security automatically for wp- pattern cookies
    const secure = window.location.protocol === 'https:' ? ';secure' : ''
    const sameSite = ';samesite=lax'

    document.cookie = `${name}=${value};${expires};path=/${secure}${sameSite}`
  }

  checkFirstTimeAccess() {
    console.log('checkFirstTimeAccess')
    // Get the taxonomy term ID from the data attribute
    const taxonomyTermId = this.dataset.taxonomyTermId
    console.log('Taxonomy Term ID:', taxonomyTermId)

    if (!taxonomyTermId) {
      console.log('No taxonomy term ID found')
      return
    }

    const accessCookie = this.getCookie(`wp-gated-access-${taxonomyTermId}`)
    const firstVisitCookie = this.getCookie(`wp-first-visit-${taxonomyTermId}`)

    console.log('Access cookie:', accessCookie)
    console.log('First visit cookie:', firstVisitCookie)
    console.log('All cookies:', document.cookie)

    // If user has access but this is their first visit after gaining access
    if (accessCookie && !firstVisitCookie) {
      console.log('Showing section - first time access detected')
      this.showSection()
      // Set first visit cookie so we don't show it again
      this.setCookie(`wp-first-visit-${taxonomyTermId}`, 'true', 30)
    } else {
      console.log('Not showing section:', {
        hasAccess: !!accessCookie,
        isFirstVisit: !firstVisitCookie,
      })
    }
  }

  showSection() {
    this.classList.remove('max-h-[0px]')
    this.classList.remove('pointer-events-none')
    this.classList.remove('opacity-0')

    this.classList.add('opacity-100')
    this.classList.add('max-h-[296px]')
  }
}

if (!customElements.get('you-are-in')) {
  customElements.define('you-are-in', YouAreIn)
}
